module.exports = __webpack_public_path__ + "static/logo-wescef-cb5d951b1be36041b1adea8e7bb5dcb1.svg";